import { useMemo } from 'react';
import { FilesListContainer } from './styled';
import AttachedFile from './file';

interface AttachedFilesProps {
    files?: File[];
    disabled?: boolean;
    onRemoveFile?: (index: number) => void;
}

const AttachedFiles = ({
    files = [],
    onRemoveFile = () => {},
    disabled = false,
}: AttachedFilesProps) => {
    const filesList = useMemo(
        () => files.map(
            (file: File, index: number) => {
                const key = `${file.name}__${index}`;
                return (
                    <AttachedFile
                        key={key}
                        file={file}
                        disabled={disabled}
                        onRemoveClick={() => onRemoveFile(index)}
                    />
                );
            },
        ),
        [files, onRemoveFile, disabled],
    );

    return (
        <FilesListContainer>{filesList}</FilesListContainer>
    );
};

export default AttachedFiles;
